import { render, staticRenderFns } from "./LinkDialog.vue?vue&type=template&id=2335d668"
import script from "./LinkDialog.vue?vue&type=script&lang=js"
export * from "./LinkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports